import React from "react";
import AppContext from "../Context/Context";
import axiosAuth from "../Axios/Interceptors";
import { useState, useEffect, useRef } from "react";

import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import DragDrop from "../DragDrop/DragDrop";
import { useGlobalState } from "../Context/GlobalStateContext";
import { DownloadClientsDataInExcel, SanitizeHtml, getAccessSettings } from "../Shared/Utility";

export default function ImporterSettings() {
  const [ImporterSettingsGridData, setImporterSettingsGridData] = useState<any>(
    []
  );
  const [showAnimation, setShowAnimation] = useState(false);
  const [canEdit, setCanEdit] = useState(false);

  const [currentView, setCurrentView] = useState(1);
  {
    /*MM:: 1 means grid view.. 2 means add view and 3 means edit view*/
  }

  const [ImporterSettingsObj, setImporterSettingsObj] = useState({}) as any;

  const [popUpMessage, setPopUpMessage] = useState("");
  const [popUpMessageModal, setPopUpMessageModal] = useState(false);

  useEffect(() => {
    IBBProgramGetPFIDealerList();
  }, []);

  function IBBProgramGetPFIDealerList() {
    let object = {} as any;
    object.appid = AppContext.App;
    object.isdeleted = false;
    object.recordsperpage = 100;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL + "api/IBBProgram/IBBProgramGetPFIDealerList",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status === 1) {
          let result = response.data.Data;
          setImporterSettingsGridData(result);
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBProgramSavePFIDealerData() {
    let object = {} as any;
    object.appid = AppContext.App;
    object.pfidealerlookupid = ImporterSettingsObj.PFIDealerLookupID;
    object.cicodejaguar = SanitizeHtml(ImporterSettingsObj.CiCodeJaguar);
    object.cicodelandrover = SanitizeHtml(ImporterSettingsObj.CiCodeLandRover);
    if (ImporterSettingsObj.IsActive == true) {
      object.isactive = 1;
    } else {
      object.isactive = 0;
    }
    debugger;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL + "api/IBBProgram/IBBProgramSavePFIDealerData",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status === 1) {
          let result = response.data.Data;
          IBBProgramGetPFIDealerList();
          setCurrentView(1);
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  return (
    <>
      {showAnimation && <LoadingAnimation />}
      {currentView == 1 && (
        <div className="page--contents">
          <div className="page--breadcrumb">
            <a>Importer Settings</a>
          </div>
          <div className="page--data">
            <div className="flex-container">
              <span></span>
              {/* <a
                className="btn-link"
                onClick={() => {
                  setImporterSettingsObj({});
                  setCurrentView(2);
                  setCanEdit(true);
                }}
              >
                Add Function
              </a> */}
                            <a
                className="btn-primary"
                title="Export"
                onClick={() =>
                  DownloadClientsDataInExcel("tblimportersettings", "IMPORTER SETTINGS")
                }
              >
                <img src="images/export.svg" width="18" height="18" />
              </a>
            </div>
            <div className="section-table">
              <table className="part-head trend-table fixed-table">
                <thead>
                  <tr>
                    <th>Market</th>
                    <th>Dealer</th>
                    <th>CI Code PFI Brand 3</th>
                    <th>CI Code PFI Brand 4</th>
                    <th>Active</th>
                    <th className="sm-col">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {ImporterSettingsGridData[0] &&
                    ImporterSettingsGridData[0].map((item: any, index: any) => (
                      <React.Fragment key={"Department" + index}>
                        <tr>
                          <td>{item.MarketName}</td>
                          <td>{item.DealerName}</td>
                          <td>{item.CiCodeJaguar}</td>
                          <td>{item.CiCodeLandRover}</td>
                          <td>{item.IsActive == true ? "Yes" : "No"}</td>
                          <td className="sm-col">
                            <div className="width-100 text-center btn-sm-grid">
                            {getAccessSettings(2, 22) > 1 &&<a
                                className="btn-primary btn-grid"
                                onClick={() => {
                                  setCurrentView(3);
                                  setImporterSettingsObj(item);
                                }}
                                title="edit"
                              >
                                <img
                                  src="images/edit.svg"
                                  width={15}
                                  height={15}
                                />
                              </a>}
                            </div>
                          </td>
                        </tr>
                      </React.Fragment>
                    ))}
                </tbody>
              </table>
               <table className="part-head trend-table fixed-table no-display" id="tblimportersettings">
                <thead>
                  <tr>
                    <th>Market</th>
                    <th>Dealer</th>
                    <th>CI Code PFI Brand 3</th>
                    <th>CI Code PFI Brand 4</th>
                    <th>Active</th>
                
                  </tr>
                </thead>
                <tbody>
                  {ImporterSettingsGridData[0] &&
                    ImporterSettingsGridData[0].map((item: any, index: any) => (
                      <React.Fragment key={"Department" + index}>
                        <tr>
                          <td>{item.MarketName}</td>
                          <td>{item.DealerName}</td>
                          <td>{item.CiCodeJaguar}</td>
                          <td>{item.CiCodeLandRover}</td>
                          <td>{item.IsActive == true ? "Yes" : "No"}</td>
                         
                        </tr>
                      </React.Fragment>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}

      {(currentView == 2 || currentView == 3 || currentView == 4) && (
        <div className="page--contents">
          <div className="page--breadcrumb">
            {currentView == 2 && canEdit && <a>Add Function</a>}
            {currentView == 3 && canEdit && <a>Edit Function</a>}
            {!canEdit && <a>Importer Setting</a>}
          </div>
          <div className="page--data">
            <div className="Importer-setting-form">
              <div className="flex-type">
                <span>Market:</span>
                <input
                  disabled
                  type="text"
                  value={ImporterSettingsObj.MarketName}
                ></input>
              </div>
              <div className="flex-type">
                <span>Dealer:</span>
                <input
                  disabled
                  type="text"
                  value={ImporterSettingsObj.DealerName}
                ></input>
              </div>
              <div className="flex-type">
                <span>CI Code PFI Brand 3:</span>
                <textarea
                  value={ImporterSettingsObj.CiCodeJaguar}
                  onChange={(e) =>
                    setImporterSettingsObj((prevState: any) => ({
                      ...prevState,
                      CiCodeJaguar: e.target.value,
                    }))
                  }
                ></textarea>
              </div>
              <div className="flex-type">
                <span>CI Code PFI Brand 4:</span>
                <textarea
                  value={ImporterSettingsObj.CiCodeLandRover}
                  onChange={(e) =>
                    setImporterSettingsObj((prevState: any) => ({
                      ...prevState,
                      CiCodeLandRover: e.target.value,
                    }))
                  }
                ></textarea>
              </div>

              <div className="flex-type">
                <span>Active:</span>
                <input
                  type="checkbox"
                  className="imp-checkbox"
                  value={ImporterSettingsObj.IsActive}
                  defaultChecked={ImporterSettingsObj.IsActive}
                  onChange={(e) =>
                    setImporterSettingsObj((prevState: any) => ({
                      ...prevState,
                      IsActive: e.target.checked,
                    }))
                  }
                ></input>
              </div>

              <div className="form-btns" style={{ paddingLeft: 170 }}>
                <>
                  <a
                    className="btn-primary btn-grid btn-secs"
                    onClick={() => IBBProgramSavePFIDealerData()}
                  >
                    Save
                  </a>
                </>

                <a
                  className="btn-primary btn-grid btn-secs"
                  onClick={() => {
                    setCurrentView(1);
                    IBBProgramGetPFIDealerList();
                  }}
                >
                  Back to List View
                </a>
              </div>
            </div>
          </div>
        </div>
      )}

      {popUpMessageModal && (
        <div className="popup-help">
          <div className="help-popup-display">
            <div className="help-inner">
              <div className="help-head">
                <h3>Message</h3>
                <a
                  className="close-help"
                  onClick={() => setPopUpMessageModal(false)}
                >
                  <img
                    src="/images/close.svg"
                    width="15px"
                    height="15px"
                    alt="cross"
                  />
                </a>
              </div>
              <div className="buis-case plr-20">{popUpMessage}</div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
